import Box from '@mui/material/Box';

import { IExtendedCertificateFragment } from 'graphql/types';
import { ReceivedCertificateListItem } from 'common/components/ReceivedCertificateListItem';
import { PortfolioItemContentBase } from 'user/components/PortfolioItemDrawer/PortfolioItemContentBase';

export const CertificatePortfolioItemContent = (
    props: React.ComponentProps<typeof PortfolioItemContentBase>
) => {
    const { portfolioItem, onClose } = props;
    const { user } = portfolioItem || {};

    const receivedCertificate =
        portfolioItem?.relatedObject as IExtendedCertificateFragment;

    if (!user) return null;

    return (
        <PortfolioItemContentBase {...props}>
            <Box sx={{ px: 4, py: 2 }}>
                <ReceivedCertificateListItem
                    portfolioItemId={portfolioItem.id}
                    receivedCertificate={receivedCertificate}
                    userId={user.id}
                    onDelete={onClose}
                />
            </Box>
        </PortfolioItemContentBase>
    );
};
